export enum ImageEnum {
  DOCTOR_IMAGE = '/assets/images/doctor-image.svg',
  COMPANY_ICON = '/assets/icons/company-image.svg',
  FAV_ICON = '/assets/icons/fav_icon.svg',
  LOGIN_GIF = '/assets/icons/login.gif',
  MAIL_ICON = '/assets/icons/mail.svg',
  USER_ICON = '/assets/icons/user.svg',
  DASHBOARD_WHITE = '/assets/icons/layout-dashboard-white.svg',
  DASHBOARD_BLACK = '/assets/icons/layout-dashboard-black.svg',
  FILE_STACK_BLACK = '/assets/icons/file-stack-black.svg',
  FILE_STACK_WHITE = '/assets/icons/file-stack-white.svg',
  ACTIVITY_BLACK = '/assets/icons/activity-black.svg',
  ACTIVITY_WHITE = '/assets/icons/activity-white.svg',
  COMPANY_LOGO_BLUE = '/assets/icons/company-logo.svg',
  WHITE_LOGO_BLUE = '/assets/icons/white-company-logo.svg',
  ARROW_WHITE = '/assets/icons/Vector.svg',
  LOGOUT_ICON = '/assets/icons/log-out.svg',
  BELL_ICON = '/assets/icons/bell.svg',
  FILTER_ICON = '/assets/icons/filter.svg',
  SEARCH_ICON = '/assets/icons/search.svg',
  CALENDAR_ICON = '/assets/icons/calendar.svg',
  WATCH_ICON = '/assets/icons/watch.svg',
  INFO_ICON = '/assets/icons/query-blue.svg',
  BADGE_ICON = '/assets/icons/badge-blue.svg',
  BADGE_PURPLE_ICON = '/assets/icons/badge-purple.svg',
  CIRCLE_CROSS = '/assets/icons/circle-cross.svg',
  CIRCLE_CROSS_RED = '/assets/icons/circle-cross-red.svg',
  CHECK_CIRCLE = '/assets/icons/check-circle.svg',
  ALERT_CIRCLE = '/assets/icons/alert-circle.svg',
  ARROW_RIGHT = '/assets/icons/arrow-right.svg',
  ARROW_RIGHT_GREEN = '/assets/icons/arrow-right-green.svg',
  DARK_CLOCK = '/assets/icons/clock-dark.svg',
  BLUE_CLOCK = '/assets/icons/clock-blue.svg',
  ORANGE_CLOCK = '/assets/icons/clock-orange.svg',
  DARK_FILE = '/assets/icons/slat-file.svg',
  INFO_WHITE = '/assets/icons/info-white.svg',
  INFO_BLUE = '/assets/icons/info-blue.svg',
  ORANGE_FILE = '/assets/icons/orange-file.svg',
  PURPLE_FILE = '/assets/icons/purple-file.svg',
  BLUE_FILE = '/assets/icons/blue-file.svg',
  WHITE_FILE = '/assets/icons/white-file.svg',
  WHITE_NOTEPAD = '/assets/icons/notepad-text.svg',
  TROPHY_FILE = '/assets/icons/trophy.svg',
  FIRE_ICON = '/assets/icons/fire.svg',
  EMPTY_CORNER = '/assets/images/empty-corner.svg',
  MONITOR = '/assets/icons/monitor.svg',
  PULSING = '/assets/icons/pulsing-circle.svg',
  LOADER_BG_GIF = '/assets/icons/loader-bg.gif',
  CHECK_ICON ='/assets/icons/check.svg',
  QUOTE_MARK = '/assets/icons/quote-mark.svg',
  CHEVRON_RIGHT = '/assets/icons/chevron-right.svg',
  CHEVRON_RIGHT_GREEN = '/assets/icons/chevron-right-green.svg',
  CHEVRON_RIGHT_INDIGO = '/assets/icons/chevron-right-indigo.svg',
  CALCULATOR = '/assets/icons/calculator.svg',
  BOOKMARK_BLACK = '/assets/icons/bookmark-black.svg',
  BOOKMARK_WHITE = '/assets/icons/bookmark-white.svg',
  VIEW_ICON = '/assets/icons/view-action.svg',
  DELETE_ICON = '/assets/icons/trash.svg',
  PRIVACY_POLICY_ICON ='/assets/images/terms-condition.svg',
  PERFORMANCE_ACTIVE = '/assets/icons/performance_active.svg',
  PERFORMANCE_INACTIVE = '/assets/icons/performance_inactive.svg'
}
